import React from 'react';
import Modal from '../../../Components/Modal';
import Form, {ULID, TextField, Money, Radio, Actions} from '../../../Components/Form';

const EditItem = ({isOpen, setIsOpen, item, saveItem}) => {
    const title = (item && item.id) ? 'Edit item' : 'Add item';

    return <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={title} dismissible>
        {isOpen && <Inner {...{item, saveItem, title}} />}
    </Modal>
}

const Inner = ({item, saveItem, title}) => {
    return <Form data={item} onSubmit={saveItem} closeModalOnSubmit>
        <ULID name="pricingItemId" />
        <TextField name="name" label="Name" validators={[]} />
        <TextField name="description" label="Description" validators={[]} />
        <Money name="defaultUnitPrice" label="Unit Price" validators={[]} />
        <Radio layout="SmallCards" name="displayPrice" label="Display price" validators={[]}
            options={[
                {
                    label: 'Total',
                    value: 'Total',
                },
                {
                    label: 'Individual',
                    value: 'Individual',
                },
            ]}
            help={(v) => v === 'Total' ?
                '"Total" pricing will show a single price without a unit count.' :
                '"Individual" pricing will show the number of items and the price per unit.'
            }
        />
        <p className="text-muted text-sm mt-2">
            You can customize all of these details when creating invoices.
        </p>
        <Actions submit={{label: title}} cancel />
    </Form>
}

export default EditItem;